import { useMemo } from "react";
import createDOMPurify from "dompurify";

export function sanitizeProductDetails(content: string, mediaOrigin: string) {
  const purifier = createDOMPurify(window);
  purifier.addHook("uponSanitizeAttribute", (node, attribute) => {
    if (
      node.nodeName === "IMG" &&
      attribute.attrName === "src" &&
      /^\/?uploads\//.test(attribute.attrValue)
    ) {
      attribute.attrValue = new URL(
        "/" + attribute.attrValue.replace(/^\//, ""),
        mediaOrigin,
      ).href;
    }
  });
  purifier.addHook("afterSanitizeAttributes", (node) => {
    if (node.nodeName === "A" && node.hasAttribute("href")) {
      node.setAttribute("target", "_blank");
      node.setAttribute("rel", "noopener noreferrer");
    }
    if (node.nodeName === "IMG") {
      node.setAttribute("loading", "lazy");
      node.setAttribute("decoding", "async");
    }
  });
  const html = purifier.sanitize(content, {
    ALLOWED_TAGS: [
      "p", "br", "div", "span", "h1", "h2", "h3", "h4", "h5", "h6",
      "strong", "b", "em", "i", "u", "s", "del", "ul", "ol", "li",
      "blockquote", "pre", "code", "hr", "a", "img", "figure", "figcaption",
      "table", "caption", "thead", "tbody", "tfoot", "tr", "th", "td",
    ],
    ALLOWED_ATTR: [
      "href", "src", "alt", "title", "width", "height", "colspan", "rowspan", "scope", "start",
    ],
    ALLOW_DATA_ATTR: false,
    ALLOW_ARIA_ATTR: false,
  });
  const template = document.createElement("template");
  template.innerHTML = html;
  const hasContent = !!template.content.textContent?.trim() ||
    Array.from(template.content.querySelectorAll("img[src]"))
      .some((img) => !!img.getAttribute("src")?.trim());
  return hasContent ? html : "";
}

export default function ProductDetails({ content }: { content?: string }) {
  const html = useMemo(() => {
    const local = ["localhost", "127.0.0.1", "[::1]"].includes(location.hostname);
    const sanitized = sanitizeProductDetails(
      content || "",
      local ? "https://panda1818.com" : location.origin,
    );
    // The section already supplies this heading; avoid repeating an identical
    // opening heading copied from the backend editor.
    const template = document.createElement("template");
    template.innerHTML = sanitized;
    const first = template.content.firstElementChild;
    if (first?.matches("p, h1, h2, h3, h4, h5, h6") &&
        first.textContent?.trim() === "商品说明" && !first.querySelector("img, a")) {
      first.remove();
    }
    const hasContent = !!template.content.textContent?.trim() ||
      Array.from(template.content.querySelectorAll("img[src]"))
        .some((img) => !!img.getAttribute("src")?.trim());
    return hasContent ? template.innerHTML : "";
  }, [content]);
  if (!html) return null;
  return (
    <section className="product-details" aria-label="商品说明">
      <h3>商品说明</h3>
      <div className="product-details-content" dangerouslySetInnerHTML={{ __html: html }} />
    </section>
  );
}
